import { on, select, addClass, removeClass, hasClass } from 'modules/dom'
import Cookies from 'js-cookie'

const DISABLE_HELLO_BAR = 'hello-bar--visible'
const helloBar = select('.hello-bar')
const closeButton = select('.js-button-close')
const COOKIE_PROPS = { expires: 365 }
const COOKIE_NAME = 'cookie-hide-hello-bar'

export default function (el) {
    if (!Cookies.get(COOKIE_NAME)) {
        addClass(DISABLE_HELLO_BAR, helloBar)
    } else {
      removeClass(DISABLE_HELLO_BAR, helloBar)
    }
    on('click', () => {
        if (hasClass(DISABLE_HELLO_BAR, helloBar)) {
            removeClass(DISABLE_HELLO_BAR, helloBar)
            Cookies.set(COOKIE_NAME, '1', COOKIE_PROPS)
        }
    }, closeButton)
}
